$( function() {   
    $('section:in-viewport').addClass('animated');    
    checkVisibleSections();
    scrollToElem();
    scrollToUp();    

    initPhoneMask();

    initPopup();
    initSlider();


    initTabsChoice();

    initMap();
    submitForm();
});


$(window).on('load',function(){
    checkVisibleSections();
});
$(window).scroll(function(){
    checkVisibleSections();
});

function initTabsChoice() {

    $('.tabs_btn').click(function(e){
        $('.tabs_btn').removeClass('active'); 
        $('.switch_img  a').removeClass('active');
        $('.choice__tab_grup').removeClass('active');
        $('.choice__tab_grup1-item').removeClass('active');
        $(this).addClass('active');
        var href = $(this).attr('href'); 
        $(href).addClass('active');

        $(href).find('.choice__tab_grup1-item').eq(0).addClass('active');

        var idItem = $('.choice__tab_grup.active').find('.choice__tab_grup1-item.active').attr('id');
        
        $('.switch_img').find('a[href="#' +idItem + '"]').addClass('active');

        /* $(href).find('.switch_img  a').eq(0).addClass('active');             */
        e.preventDefault();
    }); 


    $('.switch_img  a').click(function(e){
        $('.switch_img  a').removeClass('active');
        $('.choice__tabs a').removeClass('active');
        $('.choice__tab_grup1-item').removeClass('active');
        $('#tab1,#tab2,#tab3').removeClass('active');
        //        $(this).addClass('active');
        var index = $(this).index();
        $('.switch_img').find('a:eq(' + index+ ')').addClass('active');
        var hrefItem = $(this).attr('href'); 
        $(hrefItem).addClass('active').parent('.choice__tab_grup').addClass('active');
        var idTab = $('.choice__tab_grup.active').attr('id');
        $('.choice__tabs').find('a[href="#' +idTab + '"]').addClass('active');

        e.preventDefault();

    });

}





function initMap() {
    if(typeof ymaps == 'undefined') return;
    $('#location__map').html('');
    var myMap, 
        myPlacemark;

    function init(){ 
        myMap = new ymaps.Map("location__map", {
            center:[55.766856,37.629295],
            zoom: 16

        }); 

        myMap.behaviors.disable('scrollZoom');

        myPlacemark = new ymaps.Placemark([55.766856,37.629295], {}, {
            iconLayout: 'default#image',
            iconImageHref: 'wp-content/themes/gabaulun/images/placmark.png',
            iconImageSize: [51, 57],
            iconImageOffset: [-11, -53]
        });

        myMap.geoObjects.add(myPlacemark);
    }
    ymaps.ready(init);
}




function initPhoneMask() {
    $('input[type="tel"]').mask("+7 (999) 999-99-99");
}

function checkVisibleSections() {
    $('section:in-viewport').addClass('animated');      


    var visiblePercent = $(window).height() / 100 * 49;
    var $sections = $([]);

    $('nav a').each(function(){
        $sections = $sections.add($(this.hash));
    });
    var $menuItems = $('nav li');
    if(!$sections.filter(':in-viewport(' + visiblePercent +')').length) return;

    $sections.removeClass('visible');
    $menuItems.find('a').removeClass('active');
    $sections.filter(':in-viewport(' + visiblePercent +')').addClass('visible');

    var id = "#" + $sections.filter('.visible').attr('id');
    $menuItems.find('a[href="' + id + '"]').closest('a').addClass('active');
}
function initSlider() {
    $('.advantages__slider ul').each(function() {
        var next = $(this).siblings('.arrow__right');
        var prev = $(this).siblings('.arrow__left');
        $(this).cycle({
            slides: ' > li',
            fx: 'scrollHorz',          
            next: next,
            prev: prev,                  
            speed: 2000,
            timeout: 3000,

            paused: false,




        });
    });
}


function scrollToElem() {
    $('nav a').click(function(e){
        var href = this.hash;
        if(!$(href).length) return;

        var distance = $(window).scrollTop() - ($(href).offset().top);
        var speed = (distance > 0) ? distance / 4 : distance * -1 / 4;

        var headerOffset = $('nav').outerHeight();

        $('html, body').animate({scrollTop: ($(href).offset().top - headerOffset)}, speed);
        e.preventDefault();
    });
}



function scrollToUp() {
    $(".btn__up").click(function() {
        $("html, body").animate({ scrollTop: 0 }, 1500);
        return false;
    });
}


function initPopup() {
    $('.order_call, .buy_one_click, .order__btn, .add_comments, .choice__btn, .send__testimonial, .ask__question, .order_tea' ).fancybox({

        minHeight:500,
        minWidth:800,

        tpl: {
            wrap:'<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin" style="background:none; box-shadow:none; padding:0;"><div class="fancybox-outer"><div class="fancybox-inner" ></div></div></div></div>',

        },
    });

}



function submitForm() {
    $(".wpcf7").on('wpcf7:mailsent', function(event){

        var popupTnx = $(this).children('form').hasClass('comments__form') ? $('#popup__tnx-comments') : $('#popup__tnx');
        console.log(this);
        console.log(popupTnx);       
        $.fancybox(popupTnx,{
            minWidth:800,
            tpl: {
                wrap:'<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin" style="background:none; box-shadow:none; padding:0;"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
                closeBtn : '<a title="Close" class="fancybox-item fancybox-close thx" href="javascript:;"></a>',
            },
        });                

        $('form').trigger('reset');
        yaCounter39607480.reachGoal("ORDER");

    });
}


function fixHeader() {
    $(window).scroll($.debounce(75, function(){

        if($(window).scrollTop() > 0) {
            $('.header__menu').addClass('scrolled');
            $('.header__float_block').addClass('hide');
        } else {
            $('.header__menu').removeClass('scrolled');
            $('.header__float_block').removeClass('hide');
        }

    }));

}
